
import { Pagination } from "element-ui";
import { Component, Prop, Vue, Watch } from "vue-property-decorator"
import { translations } from '@/mixins'
import CursorPagination from "../../../../../components/CursorPagination.vue";

@Component({
  components: {
    CursorPagination,
    [Pagination.name]: Pagination,
  },
mixins: [translations],
})
export default class EmployeeCollapse extends Vue {
  @Prop() employeeMeta!: Array<any>;
  search: string = '';
  total: number = 0;
  currentPage: number = 1;
  perPage: number = 0;
  nextCursor: any = null
  prevCursor: any = null
  isLoaded: boolean = false;
  public translate!: Function;

  @Watch('employeeMeta', { deep: true })
  onEmployeeMetaChanged(newVal: any) {
    this.isLoaded = true;
    this.total = newVal.total;
    this.currentPage = newVal.current_page;
    this.perPage = newVal.per_page;
    this.nextCursor = newVal?.next_cursor;
    this.prevCursor = newVal?.prev_cursor;
  }
  findEmployees() {
    this.$emit('findEmployees', this.search);
  }
  pageChange(data: any) {
    this.$emit('getEmployees', data);
  }
}
